import { createContext, useContext } from 'react';
import { noop } from 'lodash';
import { useLocalStorage } from '../hooks/useLocalStorage';
import {
  WeightMeasurementSystem,
  weightMeasurementSystemUnits,
  queryParamUnit,
  POUNDS_PER_GRAM,
  GRAMS_PER_POUND,
} from '../constants/measurementUnits.constants';

const WeightMeasurementSystemContext = createContext({
  system: WeightMeasurementSystem.Metric,
  setSystem: noop,
  isMetric: true,
  isImperial: false,
});

export const WeightMeasurementSystemProvider = ({ children }) => {
  const [system, setSystem] = useLocalStorage('weightMeasurementSystem', WeightMeasurementSystem.Metric);

  return (
    <WeightMeasurementSystemContext.Provider
      value={{
        system,
        setSystem,
        isMetric: system === WeightMeasurementSystem.Metric,
        isImperial: system === WeightMeasurementSystem.Imperial,
      }}
    >
      {children}
    </WeightMeasurementSystemContext.Provider>
  );
};

export const useWeightMeasurementSystemContext = (metricBase = 'g') => {
  const value = useContext(WeightMeasurementSystemContext);

  value.units = weightMeasurementSystemUnits[metricBase][value.system];

  value.queryUnits = queryParamUnit[value.units];

  return value;
};

export const useGramsScaleFactor = () => {
  const { system } = useWeightMeasurementSystemContext();

  switch (system) {
    case WeightMeasurementSystem.Metric:
      return 1;
    case WeightMeasurementSystem.Imperial:
      return POUNDS_PER_GRAM;
  }
};

export const useKilogramsScaleFactor = () => {
  const { system } = useWeightMeasurementSystemContext();

  switch (system) {
    case WeightMeasurementSystem.Metric:
      return 1;
    case WeightMeasurementSystem.Imperial:
      return 1000 * POUNDS_PER_GRAM;
  }
};

export const usePoundsScaleFactor = () => {
  const { system } = useWeightMeasurementSystemContext();

  switch (system) {
    case WeightMeasurementSystem.Metric:
      return GRAMS_PER_POUND;
    case WeightMeasurementSystem.Imperial:
      return 1;
  }
};

export default WeightMeasurementSystemProvider;
